// extracted by mini-css-extract-plugin
export default {"sizesSummaryTitle":"SizesSummary_sizesSummaryTitle__VXkDR","sizesSummaryItem":"SizesSummary_sizesSummaryItem__hfoG3","sizesSummaryTotal":"SizesSummary_sizesSummaryTotal__joodw"};